import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as ProjectAPI from './projectAPI';

export const readProject = createAsyncThunk('project/readProject', async (id, { rejectWithValue }) => {
    try {
        const response = await ProjectAPI.readProject(id );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const initialState = {
    project: null,
    error: null,
};

const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        unloadProject: state => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(readProject.fulfilled, (state, { payload }) => {
                state.project = payload;
                state.error = null;
            })
            .addCase(readProject.rejected, (state, { payload }) => {
                state.project = null;
                state.error = payload;
            })
    },
});

export const { unloadProject } = projectSlice.actions;
export default projectSlice.reducer;